import type { Prompt, PromptFolder } from ".";

export type DocGenPrompts = DocxIterationPrompt | PptxIterationPrompt;

/* eslint-disable @typescript-eslint/naming-convention */
export const docGenPromptFolders = {
	"docx-iteration": "doc-gen",
	"pptx-iteration": "doc-gen",
} as const satisfies Record<DocGenPrompts["name"], PromptFolder>;
/* eslint-enable @typescript-eslint/naming-convention */

/**
 * Drives the code-writing loop that edits a docx with python-docx in a sandbox. The agent only ever
 * sees the document through the output of code it runs itself, hence the file path rather than any
 * document content.
 */
export interface DocxIterationPrompt extends Prompt {
	name: "docx-iteration";
	variables: {
		documentTitle: string;
		filePath: string;
		language: string;
		query: string;
		/** `<selection>` XML of the selected content, or "" when nothing is selected. */
		selections: string;
	};
}

export interface PptxIterationPrompt extends Prompt {
	name: "pptx-iteration";
	variables: {
		documentTitle: string;
		filePath: string;
		language: string;
		query: string;
		/** `<selection>` XML of the selected slides, or "" when nothing is selected. */
		selections: string;
	};
}
